import { print } from 'graphql';
import { updateCustomFieldOptions as updateCustomFieldOptionsQuery } from 'src/graphql/customFields/customFields';
import { fetcher } from 'src/utils/fetch';
import {
  CustomFieldOption,
  TEMP_OPTION_ID_PREFIX,
} from '../CustomFieldOptionsEditor';

const isTempId = (id: string) => id.startsWith(TEMP_OPTION_ID_PREFIX);

const sameOptions = (a: CustomFieldOption[], b: CustomFieldOption[]) =>
  a.length === b.length &&
  a.every(
    (opt, index) =>
      opt.id === b[index].id &&
      opt.label === b[index].label &&
      opt.isActive === b[index].isActive,
  );

/**
 * Persists the staged option set in a single call. The backend receives the full
 * desired list in display order and works out what to create, retire, restore
 * and reorder, so one round trip covers every staged edit.
 */
export const flushOptionChanges = async (
  customFieldId: string,
  initial: CustomFieldOption[],
  draft: CustomFieldOption[],
): Promise<void> => {
  if (sameOptions(initial, draft)) return;

  const input = {
    customFieldId,
    options: draft.map((opt) => ({
      // Newly staged options have a client-side temp id and no server row yet.
      id: isTempId(opt.id) ? null : opt.id,
      label: opt.label,
      isActive: opt.isActive,
    })),
  };

  await fetcher<unknown, { input: typeof input }>(
    print(updateCustomFieldOptionsQuery),
    { input },
  )();
};
